import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {
  Box,
  Checkbox,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

const TrailersForm = ({ trailers, onAdd, onRemove, selectableTrailers }) => {
  // prettier-ignore
  const handleChange = R.ifElse(
    R.includes(R.__, trailers),
    onRemove,
    onAdd
  );

  return (
    <>
      <Box pb={3}>
        <Box>
          <Typography sx={{ mb: 2, px: 3 }}>
            {R.isEmpty(selectableTrailers) ? 'No Trailers Available' : 'Available Trailers'}
          </Typography>
        </Box>
        {selectableTrailers.map(selectableTrailer => {
          const { trailerId, vaporTightnessCode } = selectableTrailer;
          const labelId = `checkbox-list-label-${trailerId}`;
          return (
            <Fragment key={trailerId}>
              <ListItem disablePadding key={trailerId}>
                <ListItemButton
                  dense
                  onClick={() => handleChange(selectableTrailer)}
                  role={undefined}
                  sx={{ px: 3 }}
                >
                  <Checkbox
                    checked={R.includes(selectableTrailer, trailers)}
                    disableRipple
                    edge="start"
                    tabIndex={-1}
                  />
                  <ListItemText id={labelId} primary={vaporTightnessCode} />
                </ListItemButton>
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </Box>
    </>
  );
};

TrailersForm.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  selectableTrailers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  trailers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default TrailersForm;
